import { useEffect, useRef } from 'react';

import { DEFAULT_INTERVAL } from '../../../types/chat';

const useIntervalCallback = (
    callback: () => void,
    interval: number = DEFAULT_INTERVAL
): NodeJS.Timeout | undefined => {
    const timer = useRef<NodeJS.Timeout>();

    useEffect(() => {
        timer.current = setInterval(callback, interval);

        return () => {
            if (timer.current) {
                clearInterval(timer.current);
            }
        };
    }, [ callback, interval ]);

    return timer.current;
};

export default useIntervalCallback;
